var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classBtn,attrs:{"depressed":_vm.depressedBtn,"outlined":_vm.outlinedBtn,"color":_vm.colorBtn,"light":_vm.lightBtn},on:{"click":_vm.callbackBtn}},[_c('strong',{class:_vm.classText},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }